import React, { useEffect, useState } from 'react';

import { CustomResponsiveTable } from '../../../components/common/SimpleResponsiveTable';
import { Empty, notification, Button } from 'antd';
import { useHistory } from 'react-router';
import PartStore from '../../../stores/PartStore';
import { ErrorRender } from '@partsbadger/library';
import { observer } from 'mobx-react';

interface IProps {
    master_product_id: number;
}

const GroupListByPart: React.FC<IProps> = ({ master_product_id }) => {
    const [loading, setLoading] = useState<boolean>(false);

    const history = useHistory();

    const emptyTable = () => {
        return (
            <Empty
                image={Empty.PRESENTED_IMAGE_SIMPLE}
                description={<span style={{ color: '#000' }}>This part doesn't have Groups.</span>}
            />
        );
    };

    return (
        <>
            <CustomResponsiveTable
                columns={[
                    {
                        title: 'Name',
                        dataIndex: 'name',
                        width: 100,
                    },

                    {
                        title: 'Actions',
                        dataIndex: 'Action',
                        width: 150,
                        align: 'center',
                        render: (text, record) => (
                            <>
                                <Button
                                    id="action-button"
                                    type={'link'}
                                    // icon={<EyeOutlined />}
                                    onClick={() => history.push(`/my-account/parts/group/${record.id}`)}
                                    size="large"
                                >
                                    View details
                                </Button>
                            </>
                        ),
                    },
                ]}
                loading={loading}
                data={PartStore.allGroupsAssignedToThePart}
                pagination={false}
                rowClassName={() => {
                    return 'cursor-pointer';
                }}
                emptyTable={emptyTable}
            />
        </>
    );
};

export default observer(GroupListByPart);
